import { ajaxHandler, toast, spinnerElem } from './utilities/utilities';
document.addEventListener('DOMContentLoaded', function () {
    const invoiceElem = document.querySelectorAll('a[data-generate-invoice]');
    invoiceElem.forEach((elem) => {
        elem.addEventListener('click', async function (e) {
            e.preventDefault();
            const target = e.target;
            const paddleSubscriptionId = e.currentTarget.dataset.paddleSubscriptionId;
            
            const formData = new FormData();
            formData.set('action', 'platform_get_billing_invoice_url');
            formData.set('paddle_subscription_id', paddleSubscriptionId);

            const prevHTML = elem.innerHTML;

            // Send request
            try {
                elem.innerHTML = `${spinnerElem}`;
                elem.setAttribute('disabled', true);
                
                const res = await ajaxHandler(formData);
                if (res) {
                    const { success, data } = res;
                    if (success) {
                        window.href = data;
                        window.location.href = data;
                    } else {
                        toast.error(data);
                    }
                } else {
                    toast.error('Something went wrong! Please try again later.');
                }
            } catch (error) {
                toast.error(error);
            } finally {
                elem.innerHTML = `${prevHTML}`;
                elem.removeAttribute('disabled');
            }
        });
    })
});